<script>
export default {
    name: "IconCallCenter"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 163.641 163.641" xml:space="preserve"
    fill="currentColor">
        <path d="M113.88 103.102c10.552-11.119 17.274-26.826 17.274-41.82 0-27.249-22.079-49.341-49.337-49.341-27.249 0-49.334 22.085-49.334 49.341 0 6.74 1.416 13.597 3.873 20.143 6.062 13.658 17.963 24.266 33.034 28.119 2.987-3.689 7.49-5.9 12.428-5.9 8.856 0 16.066 7.204 16.066 16.063 0 8.86-7.21 16.058-16.066 16.058-6.306 0-11.883-3.678-14.499-9.17-12.955-2.851-24.317-9.354-33.146-18.28-19.439 8.306-32.047 21.531-32.047 36.462 0 25.154 159.389 25.154 159.389 0 0-18.634-19.595-34.625-47.635-41.675z"/>
        <path
            d="M71.642 121.637c.911 4.805 5.112 8.439 10.169 8.439 5.73 0 10.373-4.646 10.373-10.37s-4.643-10.37-10.366-10.37c-4.403 0-8.139 2.753-9.646 6.625-26.059-4.584-45.931-27.334-45.931-54.686 0-30.647 24.936-55.582 55.576-55.582 30.655 0 55.585 24.935 55.585 55.582h5.687C143.089 27.492 115.603 0 81.817 0c-33.783 0-61.27 27.486-61.27 61.275-.005 30.318 22.15 55.491 51.095 60.362z"/></svg>
</template>

<style scoped lang="scss">

</style>
